module.exports = __webpack_public_path__ + "static/MU-Dynamics-Logo-v3-884fa21d185d4c464cfe496e2ae2ad81.svg";